import React from 'react';
import { Button, Alert } from 'react-bootstrap';
import Popup from 'reactjs-popup';
import PropTypes from 'prop-types';

ConflictModal.propTypes = {
    show: PropTypes.bool.isRequired,
    conflicts: PropTypes.array,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    message: PropTypes.string,
    operationType: PropTypes.string
}

function ConflictModal({ show, conflicts, onConfirm, onCancel, message, operationType = "ferie" }) {

    const conflictsList = conflicts || [];

    return (
        <Popup 
            open={show} 
            closeOnDocumentClick={false}
            modal
        >
            <div className="formGroup" id="conflict-modal">
                <Alert variant="warning">
                    {message ? (
                        <div style={{ whiteSpace: 'pre-wrap', marginBottom: '15px' }}>
                            {message}
                        </div>
                    ) : (
                        <p>
                            Esistono sovrapposizioni con:
                        </p>
                    )}
                    {conflictsList.length > 0 && (
                        <div className="conflict-list-container">
                            {conflictsList.map((conflict, index) => {
                                const conflictClass = conflict.tipo === 'turno' ? 'conflict-item-turno' : 'conflict-item-ferie';
                                return (
                                    <div key={index} className={`conflict-item ${conflictClass}`}>
                                        <div>
                                            {conflict.nomeLavoratore && (
                                                <span className="conflict-worker-name">
                                                    {conflict.nomeLavoratore}:
                                                </span>
                                            )}
                                            <strong style={{ textTransform: 'capitalize' }}>
                                                {conflict.tipo || 'turno'}
                                            </strong>
                                            {conflict.giorniSovrapposti ? (
                                                <span>
                                                    {' dei giorni: '}
                                                    <span className="conflict-overlapping-days">{conflict.giorniSovrapposti}</span>
                                                </span>
                                            ) : (
                                                <span>
                                                    {' del '}
                                                    <strong>{conflict.giornoFormatted || new Intl.DateTimeFormat('it-IT', { 
                                                        weekday: 'long', 
                                                        day: '2-digit', 
                                                        month: 'long' 
                                                    }).format(new Date(conflict.giorno))}</strong>
                                                    <span className="conflict-time-info">
                                                        {' dalle '}
                                                        <span className="inEvidenza">{conflict.inizio}</span> alle{' '}
                                                        <span className="inEvidenza">{conflict.fine}</span>
                                                    </span>
                                                </span>
                                            )}
                                            {conflict.sedeDescrizione && (
                                                <span className="conflict-sede-info">
                                                    - Sede: {conflict.sedeDescrizione}
                                                    {conflict.postazioneDescrizione && 
                                                        ` - ${conflict.postazioneDescrizione}`
                                                    }
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </Alert>
                
                <div className="buttonPopup">
                    <Button 
                        className="btnGenerale" 
                        variant="flat" 
                        size="sm"
                        onClick={onCancel}
                        style={{ marginRight: '10px' }}
                        id="annulla"
                    >
                        Annulla
                    </Button>
                    <Button 
                        className="btnGenerale" 
                        variant="flat" 
                        size="sm"
                        onClick={onConfirm}
                        style={{ backgroundColor: '#dc3545', borderColor: '#dc3545' }}
                        id="procedi"
                    >
                        {operationType === 'delete_chiusura_aziendale' ? 'Procedi comunque' : 'Procedi e cancella conflitti'}
                    </Button>
                </div>
            </div>
        </Popup>
    );
}

export default ConflictModal;